/**
 * 前端 API 客户端 — 对接服务端 SQLite
 */
const API_BASE = process.env.REACT_APP_API_URL || '';
const ADMIN_TOKEN = process.env.REACT_APP_ADMIN_PASSWORD || 'shLfjc999@';

function adminHeaders(operator = 'superadmin') {
  return {
    Authorization: `Bearer ${ADMIN_TOKEN}`,
    'X-Admin-User': operator,
  };
}

async function request(path, options = {}) {
  let res;
  try {
    res = await fetch(`${API_BASE}${path}`, {
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
      ...options,
    });
  } catch {
    throw new Error('无法连接服务，请确认后端已启动（npm run dev）');
  }

  let data = null;
  try {
    data = await res.json();
  } catch {
    data = null;
  }

  if (!res.ok) {
    throw new Error(data?.error || `请求失败 (${res.status})`);
  }

  return data;
}

function ensureArray(data) {
  return Array.isArray(data) ? data : [];
}

/** 检查 API 是否可用 */
export async function initDatabase() {
  await request('/api/health');
}

/** 检查是否已有相同姓名+部门的登记 */
export async function checkRecordExists({ name, department }) {
  const params = new URLSearchParams({
    name: name.trim(),
    department: department.trim(),
  });
  return request(`/api/records/check?${params.toString()}`);
}

/** 插入申领记录；overwrite 为 true 时覆盖已有登记 */
export async function insertRecord({
  name,
  department,
  gender,
  size,
  color = '',
  remark = '',
  overwrite = false,
}) {
  return request('/api/records', {
    method: 'POST',
    body: JSON.stringify({
      name,
      department,
      gender,
      size,
      color,
      remark,
      overwrite,
    }),
  });
}

/** 查询所有申领记录（需管理权限） */
export async function getAllRecords(operator = 'superadmin') {
  const data = await request('/api/records', {
    headers: adminHeaders(operator),
  });
  return ensureArray(data);
}

/** 更新申领记录 */
export async function updateRecord(id, data, operator = 'superadmin') {
  return request(`/api/records/${id}`, {
    method: 'PUT',
    headers: adminHeaders(operator),
    body: JSON.stringify(data),
  });
}

/** 删除申领记录 */
export async function deleteRecord(id, operator = 'superadmin') {
  return request(`/api/records/${id}`, {
    method: 'DELETE',
    headers: adminHeaders(operator),
  });
}

/** 查询审计日志 */
export async function getAuditLogs(operator = 'superadmin', limit = 200) {
  const data = await request(`/api/audit-logs?limit=${limit}`, {
    headers: adminHeaders(operator),
  });
  return ensureArray(data);
}

/** 导出为 CSV 字符串 */
export async function exportRecordsToCSV() {
  const records = await getAllRecords();
  const headers = ['ID', '姓名', '部门', '性别', '尺码', '颜色', '备注', '创建时间'];
  const rows = records.map((r) => [
    r.id,
    r.name,
    r.department,
    r.gender,
    r.size,
    r.color || '',
    r.remark || '',
    r.created_at,
  ]);

  const escape = (val) => `"${String(val).replace(/"/g, '""')}"`;
  const csvLines = [
    headers.map(escape).join(','),
    ...rows.map((row) => row.map(escape).join(',')),
  ];
  return `\uFEFF${csvLines.join('\n')}`;
}
